import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import { optimizeImage } from '../lib/cms';

export default function BicycleService() {
  const bikeImg = optimizeImage(
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/cykel-clipart.png',
    400
  );

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Cykelservice | JARCon"
        description="JARCon ApS tilbyder også cykelservice til alle slags cykler til rimelige priser. Ring eller skriv aften og weekend for at aftale tid. Forhandler www.Cykelpartner.dk"
      />

      <PageHeader
        badge="Øvrige ydelser"
        title="Cykelservice"
        subtitle="JARCon ApS tilbyder også cykelservice til alle slags cykler til rimelige priser."
        breadcrumbs={[{ label: 'Cykelservice' }]}
        ctaText="Aftal tid nu"
        ctaLink="/kontakt"
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="p-8 sm:p-12 rounded-2xl bg-[#0e1622] border border-slate-800 text-center space-y-8">
          <div className="max-w-xs mx-auto p-4 bg-slate-900/60 rounded-xl border border-slate-800">
            <img
              src={bikeImg}
              alt="Cykel Clipart.png"
              className="w-48 h-auto mx-auto object-contain filter contrast-125"
            />
          </div>

          <div className="space-y-4 max-w-xl mx-auto">
            <h2 className="font-display text-2xl sm:text-3xl font-bold text-white">
              Cykelservice til rimelige priser
            </h2>
            <p className="text-slate-300 text-lg leading-relaxed">
              JARCon ApS tilbyder også cykelservice til alle slags cykler til rimelige priser.
            </p>
            <p className="text-cyan-400 font-open-sans text-base font-semibold">
              Ring eller skriv aften og weekend for at aftale tid.
            </p>
          </div>

          <div className="pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-center gap-6 text-sm font-open-sans">
            <a
              href="tel:+4522884536"
              className="px-6 py-3 rounded-lg bg-cyan-500 hover:bg-cyan-600 text-white font-bold tracking-wide transition-all whitespace-nowrap"
            >
              <i className="fa-solid fa-phone mr-2" aria-hidden="true" />
              <span className="whitespace-nowrap">+45 22 88 45 36</span>
            </a>
            <a
              href="mailto:jens@jarcon.dk"
              className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-slate-200 border border-slate-700 transition-all whitespace-nowrap"
            >
              <i className="fa-solid fa-envelope mr-2 text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap">jens@jarcon.dk</span>
            </a>
          </div>

          <div className="pt-4 text-slate-400 text-xs font-open-sans">
            <span>Forhandler </span>
            <a
              href="http://www.cykelpartner.dk/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cyan-400 hover:underline"
            >
              www.Cykelpartner.dk
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
